/** DLC labels for invite and external-attendance forms (matches InviteForm list). */
export const AVAILABLE_DLCS = [
  'Going East!',
  'Scandinavia',
  'Vive la France!',
  'Italia',
  'Beyond the Baltic Sea',
  'Road to the Black Sea',
  'Iberia',
  'Heart of Russia',
  'West Balkans',
  'Promods',
  'Oregon',
  'Washington',
  'Utah',
  'Idaho',
  'Colorado',
  'Wyoming',
  'Montana',
  'Texas',
  'Oklahoma',
  'Kansas',
  'Nebraska',
  'Missouri',
  'Arkansas',
  'Louisiana',
  'Mississippi',
  'Alabama',
  'Georgia',
  'Florida',
  'South Carolina',
  'North Carolina',
  'Tennessee',
  'Kentucky',
  'Indiana',
  'Ohio',
  'Michigan',
  'Wisconsin',
  'Minnesota',
  'Iowa',
  'Illinois',
];
